import Vue from 'vue';
import { API_HOST } from '../constants';

export default {
  get() {
    return Vue.axios.get(`${API_HOST}/setting`);
  },
};



// WEBPACK FOOTER //
// ./src/api/setting.js